// file: frontend/src/services/galleryApi.js
import api from "./api";

/** GET /api/works/latest -> [{ id,title,description,cover_image,images[] }] */
export async function getLatestWorks() {
  const { data } = await api.get("/works/latest");
  return Array.isArray(data) ? data : [];
}
